import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    title: true,
    name: 'Equipos',
    class: 'text-dark'
  },
  {
    name: 'Lecturas',
    class: 'text-secondary',
    url: '/lecturas',
    iconComponent: { name: 'cil-speedometer' },
  },
  {
    name: 'Fallas',
    url: '/fallas',
    iconComponent: { name: 'cil-drop' }
  },
  {
    title: true,
    name: 'Sistema',
    class: 'text-dark'
  },
  {
    name: 'Acerca del Sistema',
    url: '/about',
    iconComponent: { name: 'cil-description' }
  }
];
